<template>
    <div class="row product-list-wrap">
        <div
            v-for="(product, key) in product_object"
            :key="'product' + key"
            :class="listColumns(columns) + ' product-custom-md-padding'"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-offset="100"
        >
            <div class="product">
                <div
                    class="product_image bg_primary_light_white py_30 position-relative"
                    :class="{
                        'cap_category_images': shouldApplyCapCategoryClass(
                            product.category_id,
                            product.product_default_image
                        )
                    }"
                >
                    <router-link
                        :to="{
                            name: 'product_details_new',
                            params: { id_of_product: product.id }
                        }"
                    >
                    <DiscountOffer :product="product" />
                        <img
                            class="img-fluid pro_img_fluid"
                            :alt="product.name"
                            :src="product.product_default_image"
                        />
                    </router-link>
                    <!-- <DiscountOffer :product="product" /> -->
                    <ProductBottomLinks
                        :product="product"
                        :ref="`bottom-links-${product.id}`"
                        @updateFavourites="getAllFavoriteProducts"
                    />
                </div>
                <div class="product_content_main">
                    <div class="product_content mt_22">
                        <h4 class="product-sku">
                            <router-link
                                :to="{
                                    name: 'product_details_new',
                                    params: { id_of_product: product.id }
                                }"
                                >{{
                                    product.product_number | capitalize
                                }}</router-link
                            >
                        </h4>
                        <router-link
                            :to="{
                                name: 'product_details_new',
                                params: { id_of_product: product.id }
                            }"
                        >
                            <h5 class="heading5 product_list_title">
                                {{ product.name | capitalize }}
                            </h5>
                        </router-link>
                        <div
                            class="d-flex justify-content-center collapsed color_price"
                        >
                            <DisplayProductPrice :product="product" />
                            <DisplayProductColors :colors="product.colors" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="col-md-12 col-lg-12 col-xl-12 product-custom-md-padding align-self-center text-center"
            v-show="product_object.length < 1 && !isBusy"
        >
            <div class="product mb-0 text-center">
                <h3>No Products Found</h3>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import DisplayProductColors from "@/components/DisplayProductColorsNew";
 import DiscountOffer from "@/components/DiscountOfferNew";
import DisplayProductPrice from "@/components/DisplayProductPriceNew";
import ProductBottomLinks from "@/components/ProductBottomLinksNew";
import { shouldApplyCapCategoryClass as shouldApplyCapCategoryClassService } from "@/common/capCategoryImage.service";

export default {
    name: "ProductListGrid",
    components: {
        DisplayProductColors,
        DiscountOffer,
        DisplayProductPrice,
        ProductBottomLinks
    },
    props: ["product_object", "columns"],
    data() {
        return {
            pagination: false,
            isBusy: false
        };
    },
    mounted() {},
    computed: {
        ...mapGetters(["isAuthenticatedClient", "currentUserClient"])
    },
    watch: {
        // It listens to the change in props
        product_object: function () {
            if (this.isAuthenticatedClient) {
                this.getAllFavoriteProducts();
            }
        },
        isAuthenticatedClient: function (val) {
            if (val) {
                setTimeout(() => {
                    this.getAllFavoriteProducts();
                }, 100);
            }
        }
    },
    methods: {
        shouldApplyCapCategoryClass(categoryId, imageUrl) {
            return shouldApplyCapCategoryClassService(categoryId, imageUrl);
        },
        getAllFavoriteProducts() {
            let product_list_ids = this.product_object.map(
                (product) => product.id
            );
            ApiService.post("/get-favorite-by-product-ids", {
                ids: product_list_ids
            })
                .then(({ data }) => {
                    let favourite_product_ids = data.favorite.map(
                        (product) => product.product_id
                    );
                    this.product_object.forEach((product) => {
                        this.$refs[
                            `bottom-links-${product.id}`
                        ][0].is_favorite_product =
                            favourite_product_ids.includes(product.id);
                        this.$refs[
                            `bottom-links-${product.id}`
                        ][0].favorite_product = data.favorite.find(
                            (fav) => fav.product_id == product.id
                        );
                    });
                })
                .catch((response) => {
                    console.log(response);
                });
        },
        listColumns(columns = 3) {
            if (columns == "2") {
                return "col-md-6 col-lg-6 col-xl-6";
            } else if (columns == "3") {
                return "col-md-6 col-lg-6 col-xl-3";
            } else {
                // 4
                return "col-md-6 col-lg-6 col-xl-2";
            }
        }
    }
};
</script>

<style>
    .product_list_vtwo .product .product_image .img-fluid {
        max-width: 100% !important;
        object-fit: contain !important;
    }
     .pro_img_fluid{
        margin: 0 auto;
        display: block;
    }
   

</style>
